export default __webpack_public_path__ + "static/media/delete-member-button.4a630a0b.svg";